import { useSelector } from 'react-redux';
import { filter } from 'lodash';
import { PermissionName } from 'type';
import { hasPermission } from 'lib/helpers';
import { getCurrentUserPermissions } from 'state/Auth';

export const usePermissionsFilter = () => {
  const currentUserPermissions = useSelector(getCurrentUserPermissions);

  return <FilteredItem extends { permission: PermissionName | undefined }>(
    items: FilteredItem[]
  ): FilteredItem[] =>
    filter(items, ({ permission }) =>
      hasPermission(currentUserPermissions, permission)
    );
};
